module.exports = {
	"LEADING_BID_MES": "Du har högsta budet",
	"NOT_LEADING_BID_MES": "Ditt bud har överskrivits",
	"OBJECTS": "Objekt",
	"PROCESSING_MES": "Pågående",
	"VIDEO_PLAYER_MES": "Vänligen notera att videobilden kan vara fördröjd. Buden uppdaters i realtid",
	"VIDEO_NOT_PLAYED_MES": "Denna apparat stöder inte realtidsvideo. Du kan dock lämna bud på objekten.",
	"NOT_LOGGED_IN_USER_MES": "Du måste vara inloggad för att göra bud.",
	"NEW_BID": "Gör ett nytt bud",
	"READ_MORE": "Läs mera...",
	"LESS": "Stäng...",
	"LAST_LOWER_BID_MES": "Ett lika stort bud har getts tidigare av en tredje part. Vänligen höj ditt bud för att ha det högsta budet. ",
	"START_PRICE": "Utropspris",
	"HIGHEST_BID": "Högsta budet",
	"WON_BID": "Ditt bud vann",
	"HAMMER_PRICE": "Klubbbat pris",
	"MES_WAITING_APPROVE": "Ditt bud inväntar bekräftelse",
	"MES_BEFORE_AUCTION": "Bilden uppdateras innan auktionen börjar",
	"I_AGREE_WITH": "Jag accepterar",
	"TERM": "villkoren",
	"CLOSE": "Stäng",
	"YOUR_BID": "Ditt bud",
	"Need help?": "Behöver du hjälp?"
};


/*****************
 ** WEBPACK FOOTER
 ** ../data/locale/sv.json
 ** module id = 26
 ** module chunks = 0
 **/